import request from "@/utils/request.js"
// 合作伙伴 - 合作商列表

export function get_list1(data){
  return request({
          method:'GET',
          url:'/aohua.partners/get_list1',
          params:data
    })
}
// 合作伙伴 - 面试
export function get_list2(data){
  return request({
          method:'GET',
          url:'/aohua.partners/get_list2',
          params:data
    })
}

// 合作伙伴 - 面试 - 详情
export function get_list2_detail(data){
    return request({
            method:'GET',
            url:'/aohua.partners/get_list2_detail',
            params:data
      })
  }
